import { NavLink, useNavigate } from "react-router-dom";
import { useState } from "react";
import cardinLogo from "../assets/images/Cardincompanylogo.png";

/* ---------- Nav item ---------- */
function NavItem({ to, children }) {
  return (
    <NavLink
      to={to}
      className={({ isActive }) =>
        `text-[13px] font-medium transition ${
          isActive
            ? "text-slate-900"
            : "text-slate-600 hover:text-slate-900"
        }`
      }
    >
      {children}
    </NavLink>
  );
}

/* ---------- Search icon ---------- */
function SearchIcon(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
      <path
        d="M10.5 18a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15Z"
        stroke="currentColor"
        strokeWidth="1.8"
      />
      <path
        d="M16.6 16.6 21 21"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  );
}

/* ---------- Navbar ---------- */
export default function Navbar() {
  const navigate = useNavigate();
  const [q, setQ] = useState("");

  function onSubmit(e) {
    e.preventDefault();
    if (!q.trim()) return;
    navigate("/gelatinas");
  }

  return (
    <header className="sticky top-0 z-50 bg-white/80 backdrop-blur border-b border-black/5">
      <div className="mx-auto max-w-7xl px-6 py-4 flex items-center justify-between">
        
        {/* LOGO */}
        <NavLink to="/" className="flex items-center">
          <img
            src={cardinLogo}
            alt="Cardin Company"
            className="
              h-12 md:h-14
              w-auto
              object-contain
            "
          />
        </NavLink>

        {/* MENU */}
        <nav className="hidden md:flex items-center gap-8">
          <NavItem to="/quienes-somos">Quiénes somos</NavItem>
          <NavItem to="/gelatinas">Gelatinas</NavItem>
          <NavItem to="/donde-comprar">Dónde comprar</NavItem>
        </nav>

        {/* SEARCH */}
        <form
          onSubmit={onSubmit}
          className="
            flex items-center gap-2
            rounded-full
            border border-black/10
            bg-white
            px-3 py-2
            shadow-sm
          "
        >
          <button
            type="submit"
            className="text-slate-600 hover:text-slate-900"
            aria-label="Buscar"
          >
            <SearchIcon className="h-4 w-4" />
          </button>

          <input
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Buscar"
            className="
              w-24
              bg-transparent
              text-[13px]
              text-slate-900
              placeholder:text-slate-400
              outline-none
              transition-all
              focus:w-40
            "
          />
        </form>
      </div>
    </header>
  );
}
